import { render } from "./hotelfacilities.vue?vue&type=template&id=3dc50040"
import script from "./hotelfacilities.vue?vue&type=script&lang=js"
export * from "./hotelfacilities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__